module.exports = __webpack_public_path__ + "static/media/fp-icon-secondary.384632f4.svg";